import React, { useContext, useEffect, useRef } from "react";
import { graphics } from "../../config";
import ModalContext from "../../../../shared/context/ModalContext";
import Button from "../../../../shared/components/forms/Button";
import { trackExitButton } from "../../utils/tracking/tracking";

const ModalContent = ({ modalContext, skipUnionFlag }) => {
    const ref = useRef();
    useEffect(() => {
        if (!ref.current) {
            return;
        }
        ref.current.focus();
    }, []);

    const { Labels } = window.Config;
    const { Urls } = window.Config;

    return (
        <div className="modal__inner">
            <button
                ref={ref}
                type="button"
                className="exit-flow-btn"
                onClick={() => {
                    modalContext.hideModal();
                    trackExitButton("Kryds i pop up");
                }}
            >
                <i className="icon-remove-alt" />
            </button>
            <div className="modal__buttons">
                <Button
                    type="button"
                    className="modal__button"
                    onClick={() => {
                        trackExitButton(Labels.ExitCallMe);
                        skipUnionFlag
                            ? (window.location = Urls.CallMeUrlAkasse)
                            : (window.location = Urls.CallMeUrl);
                        modalContext.hideModal();
                    }}
                >
                    <i className="icon-mobile-alt" />
                    <strong>{Labels.ExitCallMe}</strong>
                    <span>{Labels.ExitCallMeDescription}</span>
                </Button>
            </div>
            {/* removed as of decided on 23/09/2024. Keep this comment. 
             {askForExitConsent && (
                <div className="modal__consent">
                    <strong>{Labels.ExitContactConsent}</strong>
                    <Checkbox
                        bold
                        name="ContactConsent"
                        // label={Labels.ExitContactConsent}
                        aria-required="false"
                        onChangeCallBack={e => {
                            if (e === "on")
                                form.change("ExitContactConsent", true)
                            else form.change("ExitContactConsent", false)
                        }
                        }
                        resetOnFalse
                    />
                    <div
                        className="help-text rich-text"
                        dangerouslySetInnerHTML={{
                            __html: Labels.ExitContactConsentDescription
                        }}
                    />
                </div>
            )} */}
            <a
                className="modal__cta-link"
                href={Urls.ExitUrl}
                onClick={() => {
                    trackExitButton(Labels.ExitButton);
                }}
            >
                {Labels.ExitButton}
            </a>
        </div>
    );
};
const Header = ({ children, skipUnionFlag }) => {
    const { Labels } = window.Config;

    const modalContext = useContext(ModalContext);

    const openExitDialog = () => {
        trackExitButton();
        modalContext.showModal(
            <ModalContent
                modalContext={modalContext}
                skipUnionFlag={skipUnionFlag}
            />,
            {
                title: Labels.ExitTitle,
                className: "modal--exit",
            }
        );
    };

    return (
        <header className="header">
            <img className="header__logo" src={graphics.logo} alt="HK Logo" />
            {children}
            <button
                disabled={modalContext.visible}
                onClick={() => openExitDialog()}
                className="exit-flow-btn"
                type="button"
                aria-label={Labels.ExitButton}
            >
                <i className="icon-remove-alt" />
            </button>
        </header>
    );
};

export default Header;
